import React, { useRef } from "react";
import Slider from "react-slick";
import ProductCard from "web/react/components/product-card/react/product-card";
import ProductCardDetailsCuratedAd from "web/react/components/product-card/react/product-card-details-curated-ad";
import ProductCardImageCuratedAd from "web/react/components/product-card/react/product-card-image-curated-ad";
import ProductCardSaveForLaterCuratedAd from "web/react/components/product-card/react/product-card-save-for-later-curated-ad";
import { ProductsCarouselSerializer } from "web/types/serializers";
import styles from "./curated-ads.css";

function CuratedAds({ title, products }: ProductsCarouselSerializer): JSX.Element | null {
    const sliderRef = useRef<any>(null);

    if (!products.length) {
        return null;
    }

    const slickSettings = {
        arrows: false,
        draggable: false,
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 2,
        swipe: false,
        touchMove: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 2,
                    swipe: true,
                    touchMove: true,
                    draggable: true,
                    arrows: false,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    swipe: true,
                    touchMove: true,
                    draggable: true,
                    arrows: false,
                },
            },
        ],
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.titleWrapper}>
                    <h5 className={styles.title} data-content={title}>
                        {title}
                    </h5>
                </div>
            </div>
            <div className={styles.carouselWrapper}>
                <Slider ref={sliderRef} className={styles.products} {...slickSettings}>
                    {products?.map((product) => (
                        <div
                            key={product.uid}
                            data-testid="slide"
                            className={styles.productCardWrapper}
                        >
                            <ProductCard product={product}>
                                <ProductCardImageCuratedAd />

                                <ProductCardSaveForLaterCuratedAd />

                                <ProductCardDetailsCuratedAd />
                            </ProductCard>
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
}

export default CuratedAds;
